export var ApprovalStatus = /*#__PURE__*/ function(ApprovalStatus) {
    ApprovalStatus["ApprovalRequested"] = "APPROVAL_REQUESTED";
    ApprovalStatus["ChangeRequested"] = "CHANGE_REQUESTED";
    ApprovalStatus["Approved"] = "APPROVED";
    return ApprovalStatus;
}({});
export var ApprovalObjectType = /*#__PURE__*/ function(ApprovalObjectType) {
    ApprovalObjectType["Document"] = "DOCUMENT";
    ApprovalObjectType["Task"] = "TASK";
    return ApprovalObjectType;
}({});
